// export const productionUrl = "https://server.kudumbashreesvepksd.com";
// export const developemnt = "http://localhost:5000";
export const ipUrl = "https://server.kudumbashreesvepksd.com";